<template>
<div>
    
        <v-data-table
        v-if="showdata == 'CUSTOMER CREDIT SALES'"
        :headers="headers"
        dense
        class="va-table"
        :items="summaries"
        :items-per-page="10000"
        hide-default-footer
        >
         <template v-slot:body="{ items }">
            <tbody>
                <tr v-for="(item,index) in items" :key="index">          
                     <td class="text-xs-left">
                             <template v-if="item.parent_name !=''">
                               {{ item.parent_name }}
                           </template>
                           <template v-else>
                               {{ item.customer_name }}
                           </template>

                         </td>
                         <td class="text-right">{{ $money($IsNum(item.total_kilos)) }}</td>
                         <td class="text-right">{{ $money($IsNum(item.credit_amount)) }}</td>
                         <td class="text-right">{{ $money(item.total_service_charge) }}</td>
                         <td class="text-right">{{ $money(item.total_trucking_fee) }}</td>
                         <td class="text-right">{{ $money($IsNum(item.credit_amount) + $IsNum(item.total_service_charge) + $IsNum(item.total_trucking_fee)) }}</td>
                </tr>
            </tbody>
               <tfoot >
                <tr class="font-weight-bold" >          
                    <td class="text-right" style="border-top: 1px solid #212121;">TOTAL</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTALKILOS) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(CREDIT) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(SERVICE_CHARGE) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TRUCKING) }}</td>
                    <td class="text-right" style="border-top: 1px solid #212121;">{{ $money(TOTAL) }}</td>
                </tr>
                
            </tfoot>
        </template>
        </v-data-table>
</div>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selected_date: {
        type: String,
        default: ''
    },
    showdata: {
        type: String,
        default:'CUSTOMER CREDIT SALES'
    }
  },
   data: () => ({
      summaries: [],
      headers: [
            { text: 'Customer'},
             { text: 'Kilos', align:"right" , sortable: false},
            { text: 'Credit Amount', align:"right" , sortable: false},
            { text: 'Service Charge', align:"right" , sortable: false},
            { text: 'Trucking', align:"right" , sortable: false},
            { text: 'Total Credit', align:"right" , sortable: false}
      ]
  }),
  created(){
       this.getItems()
  },
  computed:{
        CREDIT(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.credit_amount), 0)
           return total
      },
      TRUCKING(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.total_trucking_fee), 0)
           return total
      },
      SERVICE_CHARGE(){
           var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.total_service_charge), 0)
           return total
      },
      TOTALKILOS(){
              var arr = this.summaries
           let total = arr.reduce((a, o) => a += this.$IsNum(o.total_kilos), 0)
           return total
      },
      TOTAL(){
             return this.SERVICE_CHARGE + this.TRUCKING + this.CREDIT
      },
  },
  methods: {
       getItems: function() {
         this.summaries = []
         //console.log(this.selected_date)
            this.$http.post("summary/get_credit_bydate", JSON.stringify({log_date: this.selected_date})).then(response => {
                  response.data.data != null?this.summaries = response.data.data: this.summaries = []
          }).catch(e => {
           console.log(e.data)
         })
      },
  }
}
</script>
